export enum ExperimentActions {
  PAUSE = 'pause',
  START = 'start',
  RESUME = 'resume',
  STOP = 'stop'
}
